export default "__VITE_ASSET__DsQsj61O__"